import React from 'react'
import { AppProvider } from '@shopify/polaris'
import {
    BrowserRouter ,
    Link as ReactRouterLink
} from 'react-router-dom'
import ReactDOM from 'react-dom'
import createApp from '@shopify/app-bridge'
import { Provider as AppBridgeProvider, Loading } from '@shopify/app-bridge-react';
import App from './components/App'

import '@shopify/polaris/build/esm/styles.css';

const config = window.appBridgeConfig

window.app = createApp(config)
const IS_EXTERNAL_LINK_REGEX = /^(?:[a-z][a-z\d+.-]*:|\/\/)/;

function Link({children, url = '', external, ref, ...rest}) {
  // react-router only supports links to pages it can handle itself. It does not
  // support arbirary links, so anything that is not a path-based link should
  // use a reglar old `a` tag
  if (external || IS_EXTERNAL_LINK_REGEX.test(url)) {
    rest.target = '_blank';
    rest.rel = 'noopener noreferrer';
    return (
      <a href={url} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <ReactRouterLink to={url} {...rest}>
      {children}
    </ReactRouterLink>
  );
}

function AppFrame(){
    return (
           <BrowserRouter>
                <AppProvider linkComponent={Link}>
                    <AppBridgeProvider config={config}>
                        <App />
                    </AppBridgeProvider>
                </AppProvider>
           </BrowserRouter>
    )
}
ReactDOM.render(<AppFrame />, document.getElementById("app"))
